import React from 'react';
import { compose } from 'redux';
import { get } from 'lodash';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { bool, object } from 'prop-types';
import classNames from 'classnames';
import { Box } from '@landtrustinc/design-system';
import { HorizontalPackageCard } from '..';
import { HUNT_ACTIVITY, HUNT_DIY_ACTIVITY } from '../../marketplace-custom-config';
import { parseMoneyObjString } from '../../util/currency';

import css from './SectionPackages.module.css';

const SectionPackages = props => {
  const {
    listing,
    onSubmit,
    rootClassName,
    className,
    listingBookingPanel,
    sectionPackagesTitle,
    currentActivity,
  } = props;
  const publicData = get(listing, 'attributes.publicData', {});
  const { packages } = publicData;

  const showDiy =
    currentActivity === HUNT_ACTIVITY || currentActivity === HUNT_DIY_ACTIVITY || !currentActivity;

  const activityPackages = packages.filter(allPackages => {
    const { activity } = allPackages;
    return showDiy ? activity === HUNT_ACTIVITY : activity === currentActivity;
  });

  const classes = classNames(rootClassName || css.sectionPackages, className);
  const parsedPackages = activityPackages
    ? activityPackages.map(item => {
        return {
          ...item,
          price: parseMoneyObjString(item.price),
          lodgingPrice: parseMoneyObjString(item.lodgingPrice),
        };
      })
    : null;
  const parsedPublishedPackages = parsedPackages && parsedPackages.filter(item => item.isPublished);

  return (
    <div className={listingBookingPanel ? css.listingBookingPanel : classes} id="packagesMobile">
      {sectionPackagesTitle && (
        <div>
          <h3 className={css.sectionTitle}>{sectionPackagesTitle}</h3>
        </div>
      )}

      <div className={css.packageList}>
        <Box display="flex" flexDirection="column" gap="var(--spacing-6)">
          {parsedPublishedPackages &&
            parsedPublishedPackages.map(item => (
              <div className={css.packageCard} key={item.id}>
                <HorizontalPackageCard
                  listing={listing}
                  packageId={item.id}
                  item={item}
                  onClick={onSubmit}
                />
              </div>
            ))}
        </Box>
      </div>
    </div>
  );
};
SectionPackages.defaultProps = {
  listing: null,
  listingBookingPanel: null,
};

SectionPackages.propTypes = {
  listing: object,
  listingBookingPanel: bool,
};

export default compose(
  withRouter,
  injectIntl
)(SectionPackages);
